/**
 * FS Summary（readOnly）隐藏当期与上年均为 0 的行。
 * 父节点仅在自身或任一子孙有非零金额时保留。
 */
export function buildFsSummaryVisibleByFsId(
    tree: any[] | null | undefined,
    getCurrent: (node: any) => number,
    getLastYear: (node: any) => number,
    opts?: { hideLastYear?: boolean },
): Record<number, boolean> {
    const out: Record<number, boolean> = {};
    const isZero = (n: number) => Math.abs(Number(n) || 0) < 0.01;

    const visit = (node: any): boolean => {
        const kids: any[] = Array.isArray(node?.children) ? node.children : [];
        let hasVisibleChild = false;
        for (const ch of kids) {
            if (visit(ch)) hasVisibleChild = true;
        }
        const cur = getCurrent(node);
        const ly = opts?.hideLastYear ? 0 : getLastYear(node);
        const visible = !isZero(cur) || !isZero(ly) || hasVisibleChild;
        const fsId = Number(node?.fsId);
        if (Number.isFinite(fsId)) out[fsId] = visible;
        return visible;
    };

    for (const root of tree || []) {
        visit(root);
    }
    return out;
}
